import { useTranslation } from 'react-i18next'

import { CaretRightIcon, WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getFieldErrorCountKey } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import * as Styles from './styles'

const BlockErrorsRow = ({ name, errorCount, onNavigate }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Row type="button" onClick={onNavigate}>
      <Text type="bodySRegular">{name}</Text>
      <Styles.ErrorCount>
        <Styles.Count>
          <WarningIcon size={16} weight="light" color={theme.colors.danger.default} />
          <Text type="bodySRegular" color={theme.colors.danger.default}>
            {t(getFieldErrorCountKey(errorCount), { count: errorCount })}
          </Text>
        </Styles.Count>
        <CaretRightIcon size={16} weight="light" color={theme.colors.text.default} />
      </Styles.ErrorCount>
    </Styles.Row>
  )
}

export default BlockErrorsRow
